import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

import TableSmall from "./../Theme/TableSmall.js";
import Table from "./../Theme/Table.js";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Badge from "@mui/material/Badge";
import Add from "./Add";
import AddInitialPrice from "./AddInitialPrice";

import Edit from "./Edit";
import EditInitialPrice from "./EditInitialPrice";
import EditCommissionRate from "./EditCommissionRate";
import AddCommissionRate from "./AddCommisionRate";

import EditMilesRate from "./EditMilesRate";
import AddMilesRate from "./AddMilesRate";

import AddSearchRadius from "./AddSeachRadius";
import EditSearchRadius from "./EditSearchRadius";

import AddSurgePriceRate from "./AddSurgePriceRate";
import EditSurgePriceRate from "./EditSurgePriceRate";
import { Tabs, Tab, Box } from "@mui/material";

import "../modal.css";
import AddAwaitingTime from "./AddWatingTime.js";
import EditPricePerMin from "./EditPricePerMin.js";
import { PROVIDER_POSITIONS } from "../enum.js";
const VehicleTypesList = () => {
const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [initialPrices, setInitialPrices] = useState([]);
  const [commissionRates, setCommissionRates] = useState([]);

  const [milesRates, setMilesRates] = useState([]);
  const [surgePriceRates, setSurgePriceRates] = useState([]);
 
  const [searchRadiuses, setSearchRadiuses] = useState([]);
  const [waitingTimes, setWaitingTimes] = useState([]);
  const [id, setId] = useState(null);
  const [initialId, setInitialID] = useState(null);
  const [commissionlId, setCommissionID] = useState(null);
  const [milesId, setMilesId] = useState(null);
  const [surgePricesId, setSurgePricesId] = useState(null);
  const [searchRadiusId, setSearchRadiusID] = useState(null);
  const [pricePerMinId, setPricePerMinID] = useState(null);
  const [data, setData] = useState(null);
  const [initialPriceData, setInitialPriceData] = useState(null);
  const [commissionData, setCommissionData] = useState(null);
  const [milesData, setMilesData] = useState(null);
  const [surgePricesData, setSurgePricesData] = useState(null);
  const [searchRadiusData, setSearchRadiusData] = useState(null);
  const [pricePerMinData, setPricePerMinData] = useState(null);

  const getVehicleTypes = async () => {
    const response = await axios.get("vehicleTypes/").then(notify());

    setVehicleTypes(response.data);
  };

  const getInitialPrices = async () => {
    const response = await axios
      .get("initialPrices/")
      .then
      // notify()
      ();

    setInitialPrices(response.data);
  };

  const getCommissionRates = async () => {
    const response = await axios
      .get("commissionRates/")
      .then
      // notify()
      ();

    setCommissionRates(response.data);
  };

  const getMilesRates = async () => {
    const response = await axios
      .get("milesRates/")
      .then
      // notify()
      ();

    setMilesRates(response.data);
  };

  const SurgePriceRates = async () => {
    const response = await axios
      .get("surgePrices/")
      .then
      // notify()
      ();

    setSurgePriceRates(response.data);
  };

  const getSearchRadiuses = async () => {
    const response = await axios.get("searchRadiuses/").then();
    setSearchRadiuses(response.data);
  };
// waiting time
  const getWaitingTimes = async () => {
  const response = await axios.get("/wait-times").then();
    setWaitingTimes(response.data);
  };

  const showAddInitialPriceModal = () => {
    setDisplayAddInitialPriceModal(true);
  };

  const [displayAddInitialPricedModal, setDisplayAddInitialPriceModal] =useState(false);

  const hideAddInitialPriceModal = () => {
    setDisplayAddInitialPriceModal(false);
  };

  const showEditInitialPriceModal = (id) => {
    setInitialID(id);

    axios.get("/initialPrice/" + id, {}).then((res) => {
      setInitialPriceData(res.data.initialPrice);
      setDisplayEditInitialPriceModal(true);
    });
  };
  const [displayEditInitialPriceModal, setDisplayEditInitialPriceModal] =
    useState(false);

  // Hide add modal
  const hideEditInitialPriceModal = () => {
    setDisplayEditInitialPriceModal(false);
  };
  //Initial Prices

  const showAddModal = () => {
    setDisplayAddModal(true);
  };

  const [displayAddModal, setDisplayAddModal] = useState(false);

  // Hide add modal
  const hideAddModal = () => {
    setDisplayAddModal(false);
  };

  const showEditModal = (id) => {
    setId(id);

    axios.get("/vehicleType/" + id, {}).then((res) => {
      setData(res.data.vehicleType);

      setDisplayEditModal(true);
    });
  };
  const [displayEditModal, setDisplayEditModal] = useState(false);

  // Hide add modal
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  //

  const showAddSurgePricesModal = () => {
    setDisplayAddSurgePricesModal(true);
  };

  const [displayAddSurgePricesModal, setDisplayAddSurgePricesModal] =
    useState(false);

  // Hide add modal
  const hideAddSurgePricesModal = () => {
    setDisplayAddSurgePricesModal(false);
  };

  const showEditSurgePricesModal = (id) => {
    setSurgePricesId(id);

    axios.get("/surgePrice/" + id, {}).then((res) => {
      setSurgePricesData(res.data.surgePrice);
      setDisplayEditSurgePricesModal(true);
    });
  };
  const [displayEditSurgePricesModal, setDisplayEditSurgePricesModal] =
    useState(false);

  // Hide add modal
  const hideEditSurgePricesModal = () => {
    setDisplayEditSurgePricesModal(false);
  };
  //Initial Prices

  //*** */

  const showAddMilesRateModal = () => {
    setDisplayAddMilesRateModal(true);
  };

  const [displayAddAddMilesRateModal, setDisplayAddMilesRateModal] =
    useState(false);

  // Hide add modal
  const hideAddMilesRateModal = () => {
    setDisplayAddMilesRateModal(false);
  };

  const showEditMilesRateModal = (id) => {
    setMilesId(id);

    axios.get("/milesRate/" + id, {}).then((res) => {
      setMilesData(res.data.miles);
      setDisplayEditMilesRateModal(true);
    });
  };
  const [displayEditMilesRateModal, setDisplayEditMilesRateModal] =
    useState(false);

  // Hide add modal
  const hideEditMilesRateModal = () => {
    setDisplayEditMilesRateModal(false);
  };
  //Initial Prices

  //*** */

  const showAddCommissionRateModal = () => {
    setDisplayAddCommissionRateModal(true);
  };

  const [displayAddCommissionRateModal, setDisplayAddCommissionRateModal] =
    useState(false);

  // Hide add modal
  const hideAddCommissionRateModal = () => {
    setDisplayAddCommissionRateModal(false);
  };

  const showEditCommissionRateModal = (id) => {
    setCommissionID(id);

    axios.get("/commissionRate/" + id, {}).then((res) => {
      setCommissionData(res.data.commission);
      setDisplayEditCommissionRateModal(true);
    });
  };
  const [displayEditCommissionRateModal, setDisplayEditCommissionRateModal] =
    useState(false);

  // Hide add modal
  const hideEditCommissionRateModal = () => {
    setDisplayEditCommissionRateModal(false);
  };
  //Initial Prices

  const showAddSearchRadiusModal = () => {
    setDisplayAddSearchRadiusModal(true);
  };

  const [displayAddSearchRadiusModal, setDisplayAddSearchRadiusModal] =
    useState(false);

  // Hide add modal
  const hideAddSearchRadiusModal = () => {
    setDisplayAddSearchRadiusModal(false);
  };
  // waiting time

  const showAddWaitingTimeModal = () => {
    setDisplayWaitingTimeModal(true);
  };

  const [displayWaitingTimeModal, setDisplayWaitingTimeModal] = useState(false);

  // Hide add modal
  const hideWatingTimeModal = () => {
    setDisplayWaitingTimeModal(false);
  };

  const showEditSearchRadiusModal = (id) => {
    setSearchRadiusID(id);

    axios.get("/searchRadius/" + id, {}).then((res) => {
      setSearchRadiusData(res.data.searchRadius);
      setDisplayEditSearchRadiusModal(true);
    });
  };

  const showEditPricePerMinModal = (id) => {
    setPricePerMinID(id);

    axios.get("/wait-times/" + id, {}).then((res) => {
      setPricePerMinData(res.data);
      setDisplayEditPricePerMinModal(true);
    });
  };

  const [displayEditSearchRadiuseModal, setDisplayEditSearchRadiusModal] =
    useState(false);

  const [displayEditPricePerMinModal, setDisplayEditPricePerMinModal] =
    useState(false);

  // Hide add modal
  const hideEditSearchRadiusModal = () => {
    setDisplayEditSearchRadiusModal(false);
  };
  const hideEditPricePerMinModal = () => {
    setDisplayEditPricePerMinModal(false);
  };
  //Initial Prices

  const edit = "vehicleTypes";
  const detail = "viewVehicleType";

  const notify = () =>
    toast.success("VehicleTypes list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  useEffect(() => {
    getVehicleTypes();
    getInitialPrices();
    getCommissionRates();
    getSearchRadiuses();
    getWaitingTimes();
    getMilesRates();
    SurgePriceRates();
     
    getMilesRates();
    SurgePriceRates();
  }, []);
  const columns = React.useMemo(
    () => [
      {
        Header: " Type Information",
        columns: [
          {
            Header: "ID",
            accessor: "id",
            disableFilters: true,
            width: 50,
          },
          {
            Header: "Type Name",
            accessor: "typeName",
            disableFilters: true,
            width: 200,
          },
          {
            Header: "Price Per KM",
            accessor: "pricePerKM",
            disableFilters: true,
            width: 150,
          },
          {
            Header: "Surge Price Per KM",
            accessor: "surgePricePerKM",
            disableFilters: true,
            width: 160,
          },
          {
            Header: "Intercity Price Per KM",
            accessor: "outOfCityPricePerKM",
            disableFilters: true,
            width: 180,
          },
          {
            Header: "Intercity Surge Price Per KM",
            accessor: "outOfCitySurgePricePerKM",
            disableFilters: true,
            width: 210,
          },
          {
            Header: "No Of Seats",
            accessor: "noOfSeats",
            disableFilters: true,
            width: 110,
          },
          {
            Header: "Price Per Minute",
            accessor: "pricePerMinute",
            disableFilters: true,
            width: 150,
          },
          {
            Header: "Surge Price Per Minute",
            accessor: "surgePricePerMinute",
            disableFilters: true,
            width: 160,
          },
          {
            Header: "Pricing Mode",
            accessor: "pricingMode",
            disableFilters: true,
            width: 130,
            Cell: (row) => (
              <div>
                {(() => {
                  const mode = row.cell.row.original.pricingMode;
                  if (mode === "distance") {
                    return "Distance-based (Per KM)";
                  } else if (mode === "time") {
                    return "Time-based (Per Minute)";
                  } else if (mode === "both") {
                    return "Combined (KM + Time)";
                  } else {
                    return mode || "Distance-based (Per KM)";
                  }
                })()} 
              </div>
            )
          },
          {
            Header: "Min Treatment Time",
            accessor: "minimumTreatmentTime",
            disableFilters: true,
            width: 130,
          },
          {
            Header: "Initial Price",
            accessor: "initialPrice",
            disableFilters: true,
            width: 130,
          },
          {
            Header: "Min Distance (KM)",
            accessor: "minimumDistance",
            disableFilters: true,
            width: 130,
          },
          {
            Header: "Max Distance (KM)",
            accessor: "maximumDistance",
            disableFilters: true,
            width: 130,
          },

          {
            Header: "Provider Type",
            accessor: "provider_type",
            disableFilters: true,
            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.provider_type === PROVIDER_POSITIONS.AMBULANCE_PROVIDER) {
                    return "Ambulance";
                  } else if (row.cell.row.original.provider_type === PROVIDER_POSITIONS.FIRST_RESPONDER){
                    return "First Responder";
                  } 
                   else if (row.cell.row.original.provider_type === PROVIDER_POSITIONS.HOMECARE_PROVIDER){
                    return "HomeCare";
                  } 
                  else {
                    return "Ride Transport";
                  }
                })()}
              </div>
            )
          }
        ],
      },
      {
        Header: " ",
        columns: [
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                <Link
                  to={""}
                  onClick={(e) => showEditModal(row.cell.row.original.id)}
                >
                  <i className="fas fa-edit info" />
                </Link>
              </div>
            ),
          },
        ],
      },
    ],
    []
  );
  const initialPriceColumns = React.useMemo(
    () => [
      {
        Header: " Price Information",
        columns: [
          {
            Header: "ID",
            accessor: "id",
            disableFilters: true,
          },
          {
            Header: "Name",
            accessor: "name",
            disableFilters: true,
          },
          {
            Header: "Amount",
            accessor: "amount",
            disableFilters: true,
          },
        ],
      },
      {
        Header: " ",
        columns: [
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                <Link
                  to={""}
                  onClick={(e) =>
                    showEditInitialPriceModal(row.cell.row.original.id)
                  }
                >
                  <i className="fas fa-edit info" />
                </Link>
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  const commissionRateColumns = React.useMemo(
    () => [
      {
        Header: " Rate Information",
        columns: [
          {
            Header: "ID",
            accessor: "id",
            disableFilters: true,
          },
          {
            Header: "Name",
            accessor: "name",
            disableFilters: true,
          },
          {
            Header: "Percentage",
            accessor: "percentage",
            disableFilters: true,
          },
        ],
      },
      {
        Header: " ",
        columns: [
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                <Link
                  to={""}
                  onClick={(e) =>
                    showEditCommissionRateModal(row.cell.row.original.id)
                  }
                >
                  <i className="fas fa-edit info" />
                </Link>
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  const milesRateColumns = React.useMemo(
    () => [
      {
        Header: " Rate Information",
        columns: [
          {
            Header: "ID",
            accessor: "id",
            disableFilters: true,
          },
          {
            Header: "Name",
            accessor: "name",
            disableFilters: true,
          },
          {
            Header: "Miles Per KM",
            accessor: "milesPerKM",
            disableFilters: true,
          },
        ],
      },
      {
        Header: " ",
        columns: [
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                <Link
                  to={""}
                  onClick={(e) =>
                    showEditMilesRateModal(row.cell.row.original.id)
                  }
                >
                  <i className="fas fa-edit info" />
                </Link>
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  const surgePriceRateColumns = React.useMemo(
    () => [
      {
        Header: " Rate Information",
        columns: [
          {
            Header: "ID",
            accessor: "id",
            disableFilters: true,
          },
          {
            Header: "Name",
            accessor: "name",
            disableFilters: true,
          },
          {
            Header: "From Time",
            accessor: "fromTime",
            disableFilters: true,
          },
          {
            Header: "To Time",
            accessor: "toTime",
            disableFilters: true,
          },
        ],
      },
      {
        Header: " ",
        columns: [
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                <Link
                  to={""}
                  onClick={(e) =>
                    showEditSurgePricesModal(row.cell.row.original.id)
                  }
                >
                  <i className="fas fa-edit info" />
                </Link>
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  const searchRadiusColumns = React.useMemo(
    () => [
      {
        Header: " Radius Information",
        columns: [
          {
            Header: "ID",
            accessor: "id",
            disableFilters: true,
          },
          {
            Header: "Name",
            accessor: "name",
            disableFilters: true,
          },
          {
            Header: "Distance",
            accessor: "distance",
            disableFilters: true,
          },
        ],
      },
      {
        Header: " ",
        columns: [
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                <Link
                  to={""}
                  onClick={(e) =>
                    showEditSearchRadiusModal(row.cell.row.original.id)
                  }
                >
                  <i className="fas fa-edit info" />
                </Link>
              </div>
            ),
          },
        ],
      },
    ],
    []
  );
   
  const WaitingTimeColumns = React.useMemo(
    () => [
      {
        Header: " Wating Time Information",
        columns: [
          {
            Header: "ID",
            accessor: "id",
            disableFilters: true,
          },
          {
            Header: "Name",
            accessor: "name",
            disableFilters: true,
          },
          {
            Header: "Price per min",
            accessor: "pricePerMin",
            disableFilters: true,
          },
        ],
      },
      {
        Header: " ",
        columns: [
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,

            Cell: (row) => (
              <div>
                {(() => {
                  if (row.cell.row.original.status == "Active") {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="success"
                      >
                        {" "}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge
                        badgeContent={row.cell.row.original.status}
                        color="warning"
                      >
                        {" "}
                      </Badge>
                    );
                  }
                })()}
              </div>
            ),
          },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                <Link
                  to={""}
                  onClick={(e) =>
                    showEditPricePerMinModal(row.cell.row.original.id)
                  }
                >
                  <i className="fas fa-edit info" />
                </Link>
              </div>
            ),
          },
        ],
      },
    ],
    []
  );
  return (
    <div className="content-wrappers" style={{paddingLeft:"30px", marginLeft: "-27px",}}>
    <ToastContainer />
      <br />
      <br />
      <br />
      <section className="content" >
        <div className="container-fluid">
          <Tabs value={currentTab} onChange={handleTabChange}>
            <Tab label="Vehicle Types"/>
            <Tab label="Initial Price" />
            <Tab label="Commission Rates"/>
            <Tab label="Miles Rates" />
            <Tab label="Surge Price Rates"/>
            <Tab label="Search Radius" />
            <Tab label="Waiting Time Per Min"/>
          </Tabs>

          {currentTab === 0 && (
            
            <TabPanel value={currentTab} index={0} >
            <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Vehicle Types</h3>
                    <Button
                      onClick={() => showAddModal()}
                      className="btn btn-success bt"
                    >
                      Add
                    </Button>
                  </div>
                   <div className="card-bodys" style={{overflowX: 'auto'}}>
                    <Table
                      columns={columns}
                      data={vehicleTypes}
                      edit={edit}
                      detail={detail}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
          )}
          {currentTab === 1 && (
            <TabPanel value={currentTab} index={1}>
              <div className="col-6">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Initial Price</h3>
                    <Button
                      onClick={() => showAddInitialPriceModal()}
                      className="btn btn-success bt"
                    >
                      Add
                    </Button>
                  </div>
                   <div className="card-body">
                    <TableSmall
                      columns={initialPriceColumns}
                      data={initialPrices}
                      edit={edit}
                      detail={detail}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
          )}

          {currentTab === 2 && (
            <TabPanel value={currentTab} index={2}>
              <div className="col-6">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Commission Rates</h3>
                    <Button
                      onClick={() => showAddCommissionRateModal()}
                      className="btn btn-success  bt"
                    >
                      Add
                    </Button>
                  </div>

                  <div className="card-body">
                    <TableSmall
                      columns={commissionRateColumns}
                      data={commissionRates}
                      edit={edit}
                      detail={detail}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
          )}

          {currentTab === 3 && (
            <TabPanel value={currentTab} index={3}>
              <div className="col-6">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Miles Rates</h3>
                    <Button
                      onClick={() => showAddMilesRateModal()}
                      className="btn btn-success  bt"
                    >
                      Add
                    </Button>
                  </div>

                  <div className="card-body">
                    <TableSmall
                      columns={milesRateColumns}
                      data={milesRates}
                      edit={edit}
                      detail={detail}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
          )}
          {currentTab === 4 && (
            <TabPanel value={currentTab} index={4}>
              <div className="col-6">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Surge Price Rates</h3>
                    <Button
                      onClick={() => showAddSurgePricesModal()}
                      className="btn btn-success  bt"
                    >
                      Add
                    </Button>
                  </div>

                  <div className="card-body">
                    <TableSmall
                      columns={surgePriceRateColumns}
                      data={surgePriceRates}
                      edit={edit}
                      detail={detail}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
          )}
          {currentTab === 5 && (
            <TabPanel value={currentTab} index={5}>
              <div className="col-6">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Search Radius</h3>
                    <Button
                      onClick={() => showAddSearchRadiusModal()}
                      className="btn btn-success bt"
                    >
                      Add
                    </Button>
                  </div>

                  <div className="card-body">
                    <TableSmall
                      columns={searchRadiusColumns}
                      data={searchRadiuses}
                      edit={edit}
                      detail={detail}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
          )}

          {currentTab === 6 && (
            <TabPanel value={currentTab} index={6}>
              <div className="col-6">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Waiting Time Per Min</h3>
                    <Button
                      onClick={() => showAddWaitingTimeModal()}
                      className="btn btn-success bt"
                    >
                      Add
                    </Button>
                  </div>

                  <div className="card-body">
                    <TableSmall
                      columns={WaitingTimeColumns}
                      data={waitingTimes}
                      edit={edit}
                      detail={detail}
                    />
                  </div>
                </div>
              </div>
            </TabPanel>
          )}
          {/* Similar rendering for other tabs */}
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row"></div>
        </div>
      </section>

      <Add showModal={displayAddModal} hideModal={hideAddModal} getVehicleTypes={getVehicleTypes} />
      <AddInitialPrice
        showModal={displayAddInitialPricedModal}
        hideModal={hideAddInitialPriceModal}
        getInitialPrices={getInitialPrices}
        
      />
      <AddCommissionRate
        showModal={displayAddCommissionRateModal}
        hideModal={hideAddCommissionRateModal}
        getCommissionRates={getCommissionRates}
      />
      <AddSearchRadius
        showModal={displayAddSearchRadiusModal}
        hideModal={hideAddSearchRadiusModal}
        getSearchRadiuses={getSearchRadiuses}
      />
      <AddAwaitingTime
        showModal={displayWaitingTimeModal}
        hideModal={hideWatingTimeModal}
        getWaitingTimes={getWaitingTimes}
      />
      <AddMilesRate
        showModal={displayAddAddMilesRateModal}
        hideModal={hideAddMilesRateModal}
        getMilesRates={getMilesRates}
      />
      <AddSurgePriceRate
        showModal={displayAddSurgePricesModal}
        hideModal={hideAddSurgePricesModal}
        SurgePriceRate={SurgePriceRates}
      />
      {displayEditModal == true && (
        <Edit
          id={id}
          data={data}
          showModal={displayEditModal}
          hideModal={hideEditModal}
          getVehicleTypes={getVehicleTypes} 
          getWaitingTimes={getWaitingTimes}
        />
      )}
      {displayEditInitialPriceModal == true && (
        <EditInitialPrice
          id={initialId}
          data={initialPriceData}
          showModal={displayEditInitialPriceModal}
          hideModal={hideEditInitialPriceModal}
          getInitialPrices={getInitialPrices}
        />
      )}
      {displayEditCommissionRateModal == true && (
        <EditCommissionRate
          id={commissionlId}
          data={commissionData}
          showModal={displayEditCommissionRateModal}
          hideModal={hideEditCommissionRateModal}
          getCommissionRates={getCommissionRates}
        />
      )}

      {displayEditMilesRateModal == true && (
        <EditMilesRate
          id={milesId}
          data={milesData}
          showModal={displayEditMilesRateModal}
          hideModal={hideEditMilesRateModal}
        />
      )}

      {displayEditSurgePricesModal == true && (
        <EditSurgePriceRate
          id={surgePricesId}
          data={surgePricesData}
          showModal={displayEditSurgePricesModal}
          hideModal={hideEditSurgePricesModal}
          SurgePriceRate={SurgePriceRates}
        />
      )}

      {displayEditSearchRadiuseModal == true && (
        <EditSearchRadius
          id={searchRadiusId}
          data={searchRadiusData}
          showModal={displayEditSearchRadiuseModal}
          hideModal={hideEditSearchRadiusModal}
          getSearchRadiuses={getSearchRadiuses}
        />
      )}
      {displayEditPricePerMinModal == true && (
        <EditPricePerMin
          id={pricePerMinId}
          data={pricePerMinData}
          showModal={displayEditPricePerMinModal}
          hideModal={hideEditPricePerMinModal}
          getWaitingTimes={getWaitingTimes}
          
        />
      )}
    </div>
  );
};

const TabPanel = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};
export default VehicleTypesList;
